(function(){

	let scrollbarWidth = window.innerWidth - document.body.clientWidth;
	document.documentElement.style.setProperty('--scrollbar-size-px', scrollbarWidth + 'px');

	if (typeof ScrollMagic != 'undefined') {
        var section = document.querySelectorAll('.js-anime:not(.is-active)');
        var controller = new ScrollMagic.Controller();
        if (section.length != 0) {
            Array.prototype.slice.call(section).forEach(function (sec, index) {
                var scene = new ScrollMagic.Scene({
                    triggerElement: sec,
                    triggerHook: sec.dataset.hook || 'onCenter',
                    offset: sec.dataset.offset || -100,
                    reverse: false
                })
                // .addIndicators( {name: "scroll"})
                .addTo(controller);
                scene.on('enter', function (event) {
                    sec.classList.add('is-active');
                });
            });
        }
		let controllerTop = new ScrollMagic.Controller();
		let sceneTop = new ScrollMagic.Scene({
			triggerElement: '.anchor-btn-wrapper',
			triggerHook: 'onEnter',
			offset: 100,
		})
		//  .addIndicators( {name: "scroll"})
		.addTo(controllerTop);
		sceneTop.on('enter', function (event) {
			$('.anchor-btn').removeClass("is-fixed");
		});
		sceneTop.on('leave', function (event) {
			$('.anchor-btn').addClass("is-fixed");
		});
    }

	$(window).on('scroll', function(){
		let y = window.pageYOffset;
		let offset = $('.column-container').offset().top;
		if(y > offset) {
			$('.anchor-btn').addClass("is-show");
		}
		if(y <= offset) {
			$('.anchor-btn').removeClass("is-show");
		}
	});

	$('.anchor-btn').on('click', function(){
		$("body,html").animate({scrollTop: 0},"300","swing")
	})


})();
